import React, { useState, useEffect } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        if (onClose) onClose();
      }, 300); // Wait for fade out animation
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300); // Wait for fade out animation
  };

  const typeClasses = {
    success: 'bg-success',
    error: 'bg-danger',
    warning: 'bg-warning',
    info: 'bg-info'
  };

  return (
    <div 
      className={`toast-container position-fixed top-0 p-3 ${visible ? 'show' : 'hide'}`}
      style={{ zIndex: 1070, left: '50%', transform: 'translateX(-50%)' }}
    >
      <div 
        className={`toast show ${typeClasses[type] || 'bg-dark'}`}
        role="alert" 
        aria-live="assertive" 
        aria-atomic="true"
      >
        <div className="toast-header">
          <strong className="me-auto">
            {type === 'success' && 'Success'}
            {type === 'error' && 'Error'}
            {type === 'warning' && 'Warning'}
            {type === 'info' && 'Information'}
          </strong>
          <button 
            type="button" 
            className="btn-close" 
            aria-label="Close"
            onClick={handleClose}
          ></button>
        </div>
        <div className="toast-body text-white">
          {message}
        </div>
      </div>
    </div>
  );
};

export default Toast;
